module.exports = __webpack_public_path__ + "img/selected7-min.ef7f60d3.png";